module.exports = __webpack_public_path__ + "static/media/load.c7da05a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result/load.svg
// module id = 3001
// module chunks = 0